const getPaymentStatusFromOrderState = (orderState) => {
    switch (orderState) {
        case 'error': {
            return 'ERROR';
        }
        case 'completed': {
            return 'COMPLETE';
        }
        case 'returned': {
            return 'ACCEPTED';
        }
        default:
            return 'WAITING';
    }
};
export default getPaymentStatusFromOrderState;
